import axios from 'axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

var instance = axios.create();

const servicesAPI = {
  obtenerReminders(filter = {}) {
    var url = ConfigAPI.baseURL + "reminders" + Session.getToken()

    if (filter.status) url += "&status=" + filter.status
    if (filter.date_start) url += "&date_start=" + filter.date_start
    if (filter.date_end) url += "&date_end=" + filter.date_end

    return instance.get(url);
  },
  agregarReminder(data) {
    var url = ConfigAPI.baseURL + "reminders" + Session.getToken();
    return instance.post(url, data);
  },
  editarReminder(data) {
    var url = ConfigAPI.baseURL + "reminders/" + data.id + Session.getToken();
    return instance.post(url, data);
  },
  eliminarReminder(id) {
    var url = ConfigAPI.baseURL + "reminders/" + id + Session.getToken();
    return instance.delete(url);
  },
  completarReminder(id) {
    var url = ConfigAPI.baseURL + "reminders/" + id + "/complete" + Session.getToken();
    return instance.post(url);
  },

  obtenerStaff() {
    var url = ConfigAPI.baseURL + "staff" + Session.getToken();
    return instance.get(url);
  },
  obtenerRoles() {
    var url = ConfigAPI.baseURL + "roles" + Session.getToken();
    return instance.get(url);
  },
}

export default servicesAPI;
